import { useState } from 'react';
import { usePasswordValidation } from 'src/hooks/usePasswordValidation';
import { NewPasswordForm } from '../components/NewPasswordForm';
import { useResetPasswordStep } from '../steps/resetPasswordStep';

interface IResetPasswordStepContainerProps {
  username: string;
  otpToken: string;
  onSuccess: () => void;
  onBack: () => void;
  onSessionExpired?: () => void;
}

export const ResetPasswordStepContainer = ({
  username,
  otpToken,
  onSuccess,
  onBack,
  onSessionExpired,
}: IResetPasswordStepContainerProps) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const { validation, isValid } = usePasswordValidation(password, confirmPassword);

  const { loading, handleResetPassword } = useResetPasswordStep({
    username,
    otpToken,
    onSuccess,
    onSessionExpired,
  });

  return (
    <>
      <NewPasswordForm
        password={password}
        confirmPassword={confirmPassword}
        validation={validation}
        isValid={isValid}
        loading={loading}
        onPasswordChange={setPassword}
        onConfirmPasswordChange={setConfirmPassword}
        onSubmit={() => handleResetPassword(password, isValid)}
        onBack={onBack}
      />
    </>
  );
};
